module.exports = __webpack_public_path__ + "img/mta.12d0a364.jpg";